import App from "./src/App";
import {createContext, useContext} from "react";
import {replaceInObject} from "../utils";
import {useAppContext} from "../Main";

const LandingContext = createContext({});
export const useLandingContext = () => useContext(LandingContext);

export const Landing = () => {
    const {data, VKButton, onVKButtonClick} = useAppContext();

    const APP_DATA = {...data.settings.landing};

    APP_DATA.footer = data.settings.dashboard.footer;
    APP_DATA.faqTitle = data.settings.dashboard.faqTitle;

    APP_DATA.methodsTitle = data.settings.dashboard.PAYMENT_DATA.methodsTitle;
    APP_DATA.cancelNotice = data.settings.dashboard.PAYMENT_DATA.cancelNotice;
    APP_DATA.methods = data.settings.dashboard.PAYMENT_DATA.methods;

    APP_DATA.congratulation = data.settings.dashboard.congratulation;
    APP_DATA.cityTitle = data.settings.dashboard.cityTitle;
    APP_DATA.cta = data.settings.dashboard.cta;
    APP_DATA.cta2 = data.settings.dashboard.cta2;
    APP_DATA.success = data.settings.dashboard.success;
    APP_DATA.ok = data.settings.dashboard.ok;
    APP_DATA.ctaActivation = data.settings.dashboard.ctaActivation;
    APP_DATA.withoutCard = data.settings.dashboard.withoutCard;
    APP_DATA.month = data.settings.dashboard.month;
    APP_DATA.year = data.settings.dashboard.year;
    APP_DATA.brandBadge = data.settings.dashboard.brandBadge;
    APP_DATA.analysisSubTitle = data.settings.dashboard.analysisSubTitle;
    APP_DATA.tariffsTitle = data.settings.dashboard.tariffsTitle;
    APP_DATA.tariffTitle = data.settings.dashboard.tariffTitle;
    APP_DATA.tariffsMonth = data.settings.dashboard.tariffsMonth;
    APP_DATA.tariffsDiscount = data.settings.dashboard.tariffsDiscount;
    APP_DATA.tariffsAnnual = data.settings.dashboard.tariffsAnnual;
    APP_DATA.tariffSelected = data.settings.dashboard.tariffSelected;
    APP_DATA.howToStartTitle = data.settings.dashboard.howToStartTitle;
    APP_DATA.samplePostTitle = data.settings.dashboard.samplePostTitle;
    APP_DATA.samplePostSubTitle = data.settings.dashboard.samplePostSubTitle;
    APP_DATA.postStructureTitle = data.settings.dashboard.postStructureTitle;
    APP_DATA.postStructureSubtitle = data.settings.dashboard.postStructureSubtitle;
    APP_DATA.heroPrimaryCta = data.settings.dashboard.heroPrimaryCta;
    APP_DATA.heroSecondaryCta = data.settings.dashboard.heroSecondaryCta;
    APP_DATA.heroTrialNote = data.settings.dashboard.heroTrialNote;

    APP_DATA.tariffs = data.settings.tariffs;
    APP_DATA.businessName = data.businessName;
    APP_DATA.brandName = data.settings.firm.name;
    APP_DATA.congratulation = APP_DATA.congratulation.replace("{{businessName}}", data.businessName);
    APP_DATA.tariffs.forEach(tariff => tariff.priceAnnual = Math.floor(tariff.priceMonthly * (1 - data.settings.annualDiscountPercent / 100)));

    for (const i in APP_DATA) {
        APP_DATA[i] = replaceInObject(APP_DATA[i], "{{firmEmail}}", data.settings.firm.email);
        APP_DATA[i] = replaceInObject(APP_DATA[i], "{{firmName}}", data.settings.firm.name);
        APP_DATA[i] = replaceInObject(APP_DATA[i], "{{year}}", new Date().getFullYear());
        APP_DATA[i] = replaceInObject(APP_DATA[i], "{{annualDiscountPercent}}", data.settings.annualDiscountPercent);
        APP_DATA[i] = replaceInObject(APP_DATA[i], "{{freeDays}}", data.settings.freeDays);
    }

    return (
        <LandingContext.Provider value={{APP_DATA, onVKButtonClick, VKButton}}>
            <App/>
        </LandingContext.Provider>
    )
}
